const USER_REFRESH_TOKEN = "jwt_key_authorization_refresh_token";
const USER_TOKEN = "jwt_key_authorization_token";
const USER_EMAIL = "bindbox_user_email";
const USER_INFO = "BINDBOX_userInfo";

export const USER_DEFAULT_LANGUAGE = "user_default_language";

export const GA_TRACKING_ID = process.env.REACT_APP_GA_ID;

export const URI_GRAPHQL = `${process.env.REACT_APP_BACKEND_PROTOCOL ||
  "http"}://${process.env.REACT_APP_GRAPHQL_SERVER || "localhost:4000"}`;
export const URL_JDC_INTERPRETER = `${process.env
  .REACT_APP_INTERPRETER_PROTOCOL || "https"}://${process.env
  .REACT_APP_INTERPRETER_URL || "ustart-jdc-interpreter.herokuapp.com"}`;
export const FEEDBACK_API = process.env.REACT_APP_FEEDBACK_API;
export const SET_JWT = (jwt) => sessionStorage.setItem(USER_TOKEN, jwt);
export const GET_JWT = () => sessionStorage.getItem(USER_TOKEN);
export const SET_REFRESH_JWT = (jwt) =>
  sessionStorage.setItem(USER_REFRESH_TOKEN, jwt);
export const GET_REFRESH_JWT = () => sessionStorage.getItem(USER_REFRESH_TOKEN);
export const SET_ROLES = (roles) => sessionStorage.setItem(USER_ROLES, roles);
export const GET_ROLES = () => sessionStorage.getItem(USER_ROLES);
export const REMOVE_JWT = () => sessionStorage.removeItem(USER_TOKEN);
export const REMOVE_REFRESH_JWT = () =>
  sessionStorage.removeItem(USER_REFRESH_TOKEN);
export const REMOVE_ROLES = () => sessionStorage.removeItem(USER_ROLES);

export const SET_USER_EMAIL = (email) =>
  sessionStorage.setItem(USER_EMAIL, email);
export const GET_USER_EMAIL = () => sessionStorage.getItem(USER_EMAIL);
export const REMOVE_USER_EMAIL = () => sessionStorage.removeItem(USER_EMAIL);

export const REMOVE_USER_INFO = () => localStorage.removeItem(USER_INFO);

// const USER_ROLES = "user_roles";
// export const HAS_ROL = rol => {
//   const roles = GET_ROLES();
//   return roles && roles.some(r => r === rol);
// };

export const USER_ROLES = {
  regular: "USER",
  organization: "ORGANIZATION",
};
export const DEFAULT_NODE_ICON = "MdAccessibility";
export const DEFAULT_NODE_ICON_SIZE = "3em";
export const DEFAULT_NODE_ICON_COLOR = "white";
export const DEFAULT_NODE_ITEM_BACKGROUND_COLOR = "#c4d8d9";
export const DEFAULT_PORT_ICON = "m 7 7 h 10 v 10 h -10 z";

export const RELATIONSHIP_TYPE = ["belongs-to", "has-many"];
export const DEFAULT_RELATIONSHIP_TYPE = ["belongs-to", "has-many"];
export const RELATION_TYPE = {
  HAS_MANY_RELATION: "has-many",
  BELONGS_TO_RELATION: "belongs-to",
};

/* validaciones de form */

export const EMPTY_VALIDATION = "isEmpty";
export const PHONE_VALIDATION = "isMobilePhone";
export const EMAIL_VALIDATION = "isEmail";
export const SELECTED_VALIDATION = "isSelected";
export const RADIO_VALIDATION = "radioSelected";
export const MATCH_FIELD_VALIDATION = (field) => `matchField-${field}`;
export const MINLENGTH_VALIDATION = (lenght) => `minLength-${lenght}`;
export const PASSWORD_VALIDATION = "isValidPassword";

/* fin validaciones de form */
export const SHORT_NODE_NAME = (type) => {
  const splits = type.split(".");
  return splits[splits.length - 1];
};
export const GQL_TYPES = {
  MUTATION: "uStart.types.gql.mutation",
  QUERY: "uStart.types.gql.query",
};
//quantifiers props
export const QUANTIFIER_ONE = "one";
export const QUANTIFIER_MANY = "many";
export const QUANTIFIERS = [QUANTIFIER_ONE, QUANTIFIER_MANY];

//branches and shields
export const PROJECT_MASTER_BRANCH = "master";
export const PROJECT_DEVELOP_BRANCH = "develop";

export const PROJECT_SHIELD_API_KEY = "API-KEY";
